import dayjs from "dayjs";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";

import { Option } from "@/@types/generics/Option";
import { GrievanceNotification } from "@/@types/sintegrada/GrievanceNotification";
import { RiskClassification } from "@/@types/sintegrada/RiskClassification";

import { GrievanceNotificationSelect } from "@/components/sintegrada/Selects/GrievanceNotificationSelect";
import { GenderSelect } from "@/components/GenderSelect";
import { RiskClassificationSelect } from "@/components/sintegrada/Selects/RiskClassificationSelect";
import { ApplyFilterButton } from "@/components/sintegrada/Buttons/ApplyFilterButton";
import { ExportExcelButton } from "@/components/sintegrada/Buttons/ExportExcelButton";
import { FormattedControl } from "@/components/FormattedControl";
import { AgeGroup } from "@/components/sintegrada/AgeGroup";

type Props = {
	startDate: string;
	setStartDate: (startDate: string) => void;
	endDate: string;
	setEndDate: (endDate: string) => void;
	youngerAge: string;
	setYoungerAge: (youngerAge: string) => void;
	olderAge: string;
	setOlderAge: (olderAge: string) => void;
	gender?: Option<string>;
	setSelectedOptionGender: (gender: Option<string>) => void;
	selectedGrievanceNotification?: Option<GrievanceNotification>;
	setSelectedGrievanceNotification: (
		grievanceNotification: Option<GrievanceNotification>
	) => void;
	selectedOptionRiskClassification?: Option<RiskClassification>;
	setSelectedOptionRiskClassification: (riskClassification: Option<RiskClassification>) => void;
	isCheckedIndividualReport: boolean;
	handleCheckboxChange: () => void;
	handleFilter: () => void;
	handleExport: () => void;
};

export function GrievanceNotificationFilters({
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	youngerAge,
	setYoungerAge,
	olderAge,
	setOlderAge,
	gender,
	setSelectedOptionGender,
	selectedGrievanceNotification,
	setSelectedGrievanceNotification,
	selectedOptionRiskClassification,
	setSelectedOptionRiskClassification,
	isCheckedIndividualReport,
	handleCheckboxChange,
	handleFilter,
	handleExport,
}: Readonly<Props>) {
	const minDate = dayjs().subtract(2, "years").startOf("day").format("YYYY-MM-DDTHH:mm");
	const maxDate = dayjs().endOf("day").format("YYYY-MM-DDTHH:mm");
	return (
		<Form
			className="mb-8"
			onSubmit={(event) => {
				event.preventDefault();
				handleFilter();
			}}
		>
			<Row className="d-flex gap-1 mb-4">
				<Col sm={12} md={6} lg={6} xl={5} xxl={4} className="d-flex flex-column">
					<Form.Label htmlFor="start-date">Período</Form.Label>
					<div className="d-flex justify-content-between gap-1">
						<InputGroup className="w-100">
							<FormattedControl
								id="start-date"
								type="datetime-local"
								value={startDate}
								placeholder="Data inicial"
								min={minDate}
								max={maxDate}
								onChange={(event) => setStartDate(event.target.value)}
							/>
						</InputGroup>

						<InputGroup className="w-100">
							<FormattedControl
								type="datetime-local"
								value={endDate}
								placeholder="data final"
								min={startDate}
								max={maxDate}
								onChange={(event) => setEndDate(event.target.value)}
							/>
						</InputGroup>
					</div>
				</Col>

				<Col sm={12} md={5} lg={4} xl={3} xxl={3}>
					<GrievanceNotificationSelect
						value={selectedGrievanceNotification}
						onChange={(event) =>
							setSelectedGrievanceNotification(event as Option<GrievanceNotification>)
						}
					/>
				</Col>

				<Col sm={12} md={5} lg={4} xl={3} xxl={3}>
					<RiskClassificationSelect
						value={selectedOptionRiskClassification}
						onChange={(event) =>
							setSelectedOptionRiskClassification(event as Option<RiskClassification>)
						}
					/>
				</Col>
			</Row>

			<Row className="d-flex gap-1">
				<Col sm={12} md={2} lg={2} xl={2} xxl={2}>
					<GenderSelect
						value={gender}
						labelClassNames="form-label"
						onChange={(event) => setSelectedOptionGender(event as Option<string>)}
					/>
				</Col>
				<Col sm={12} md={5} lg={4} xl={3} xxl={3}>
					<AgeGroup
						minAge={youngerAge}
						maxAge={olderAge}
						handleChangeMinAge={(value) => setYoungerAge(value)}
						handleChangeMaxAge={(value) => setOlderAge(value)}
					/>
				</Col>

				<Col sm={12} md={5} lg={4} xl={3} xxl={3} className="d-flex">
					<div className="d-flex align-items-end mx-8 mb-1">
						<Form.Check
							id="individual"
							type="checkbox"
							label={"Individual"}
							checked={isCheckedIndividualReport}
							onChange={handleCheckboxChange}
						/>
					</div>

					<div className="d-flex align-items-end gap-4">
						<ApplyFilterButton type="submit" />

						<ExportExcelButton onClick={handleExport} />
					</div>
				</Col>
			</Row>
		</Form>
	);
}
